"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useCallback } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import SubmissionCarousel, { type SubmissionCarouselHandle } from "./carousel/SubmissionCarousel";
import CarouselActiveItemVote from "./carousel/CarouselActiveItemVote";
import CarouselActiveItemDetails from "./carousel/CarouselActiveItemDetails";
import { NowMintingSection } from "./now-minting";
import { NextMintLeadingSection } from "./next-mint-leading";
import { BoostedSection } from "./boosted";
import { ExploreWavesSection } from "./explore-waves";
import { CarouselHeader, HeroHeader } from "./hero";
export default function HomePageContent() {
  const $ = _c(16);
  const [activeDrop, setActiveDrop] = useState(null);
  const carouselRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => carouselRef.current?.pauseAutoplay();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const pauseAutoplay = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => carouselRef.current?.resumeAutoplay();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resumeAutoplay = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroHeader />;
    t3 = <NowMintingSection />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CarouselHeader />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-min-h-0 [@media(min-height:1200px)]:tw-max-h-[800px] [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-h-[min(70svh,600px)]"><SubmissionCarousel ref={carouselRef} onActiveDropChange={setActiveDrop} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeDrop) {
    t6 = activeDrop && <CarouselActiveItemVote drop={activeDrop} />;
    $[6] = activeDrop;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <section className="tw-grid tw-h-auto tw-grid-rows-[auto_1fr_auto] sm:tw-h-[100svh] [@media(min-height:1200px)]:tw-h-auto [@media(min-height:1200px)]:tw-grid-rows-[auto_auto_auto] [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-h-auto [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-grid-rows-[auto_auto_auto]" onMouseEnter={pauseAutoplay} onMouseLeave={resumeAutoplay}>{t4}{t5}{t6}</section>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== activeDrop) {
    t8 = <div onMouseEnter={pauseAutoplay} onMouseLeave={resumeAutoplay}><CarouselActiveItemDetails drop={activeDrop} /></div>;
    $[10] = activeDrop;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-mt-10 tw-border tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-10 md:tw-mt-16 md:tw-pt-16"><NextMintLeadingSection /><BoostedSection /><ExploreWavesSection /></div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8) {
    t10 = <div className="tw-overflow-x-hidden tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-900">{t2}{t3}{t7}{t8}{t9}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}